module.exports = __webpack_public_path__ + "img/CH_A.0982c32e.jpg";